/**
 * Coerce a money field to a number. A mistyped value such as "l'k" becomes 0
 * rather than turning a running total into a string.
 * @param value
 * @returns {number}
 */
export function toAmount(value) {
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : 0;
}

/**
 * Format a money field to 2dp without throwing on a non-numeric value
 * @param value
 * @returns {string}
 */
export function formatAmount(value) {
    return toAmount(value).toFixed(2);
}
